import { render, staticRenderFns } from "./jilu-render.vue?vue&type=template&id=6396fba5&"
import script from "./jilu-render.vue?vue&type=script&lang=ts&"
export * from "./jilu-render.vue?vue&type=script&lang=ts&"
import style0 from "./jilu-render.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports